import clsx from "clsx";
import { IconProps } from "@/types/icons";
import { createColorClasses } from "@/theme/colors";
import { useId } from "react";

export const PlayVideo = ({
  width = 73,
  height = 73,
  className,
  color,
  onClick,
  decorative = false,
  ariaLabel = "Play video",
}: IconProps) => {
  const uniqueId = useId();
  const clipPathId = `clip0_${uniqueId}`;
  const classes = createColorClasses({ color });

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 73 73"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={clsx(className, classes)}
      onClick={onClick}
      focusable="false"
      role={decorative ? "presentation" : "img"}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <circle cx="36.5" cy="36.627" r="36" fill="white" fillOpacity="0.3" />
      <circle cx="36.4991" cy="36.628" r="29.0323" fill="white" />
      <g clipPath={`url(#${clipPathId})`}>
        <path
          d="M46.7155 34.6327C47.4077 35.0604 47.8289 35.8138 47.8289 36.6254C47.8289 37.4371 47.4077 38.1904 46.7155 38.5744L32.7755 47.1286C32.0581 47.6097 31.1601 47.6292 30.4272 47.216C29.6942 46.8029 29.2402 46.0253 29.2402 45.1796V28.0713C29.2402 27.2275 29.6942 26.4494 30.4272 26.0363C31.1601 25.6236 32.0581 25.6406 32.7755 26.0805L46.7155 34.6327Z"
          fill="#0066CC"
        />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect
            width="18.5886"
            height="24.8848"
            fill="white"
            transform="translate(29.2402 24.1836)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
